import { ApiConstants } from "../../constants/ApiConstants";
import { MY_PROFILE_DETAIL, MY_PROFILE_SALON_UPDATE, MY_PROFILE_UPDATE, SALON_DETAIL } from "../Constants/MyProfileConstants";
import { createFDataAction, createFormDataAction, createPostDataAction } from "./CommonAction";



// export const CheckUserction = (payload: any) => createFormDataAction(CHECKUSER, ApiConstants?.Register, payload, true);
export const MyProfileDetailAction = (payload: any) => createPostDataAction(MY_PROFILE_DETAIL, ApiConstants?.MyProfileDetail, payload, false);
export const MyProfileUpdateAction = (payload: any) => createFormDataAction(MY_PROFILE_UPDATE, ApiConstants?.MyProfileUpdate, payload, true);
export const SalonUpdateAction = (payload: any) => createFDataAction(MY_PROFILE_SALON_UPDATE, ApiConstants?.MyProfileSalonUpdate, payload, true);
export const SalonDetailAction = (payload: any) => createPostDataAction(SALON_DETAIL, ApiConstants?.SalonDetail, payload, false);
